import { useLazyQuery } from "@apollo/client";
import { getProducts } from "../graphql/queries/product";

// eslint-disable-next-line import/prefer-default-export
export const useGetProducts = () => {
  const [getProductList, { data, loading, error }] = useLazyQuery(getProducts);

  return { execute: getProductList, data, loading, error };
};
